import { render, staticRenderFns } from "./PageMitarbeiteraktivitaet.vue?vue&type=template&id=6629f1ea&scoped=true&"
import script from "./PageMitarbeiteraktivitaet.vue?vue&type=script&lang=js&"
export * from "./PageMitarbeiteraktivitaet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629f1ea",
  null
  
)

export default component.exports